// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18nwi","left":"styles_left__30IKI"};